import * as actions from './actionTypes';

export function createProfile(profiles) {
  return {
    type: actions.CREATE_PROFILE,
    payload: profiles,
  };
}

export function deleteProfile(profiles) {
  return {
    type: actions.DELETE_PROFILE,
    payload: profiles,
  };
}

export function editProfile(profiles) {
  return {
    type: actions.EDIT_PROFILE,
    payload: profiles,
  };
}

export function getProfiles(profiles) {
  return {
    type: actions.GET_PROFILES,
    payload: [...profiles],
  };
}

export function setSelectProfile(profiles) {
  return {
    type: actions.SET_SELECT_PROFILE,
    payload: profiles,
  };
}

export function getSelectProfile(profiles) {
  return {
    type: actions.GET_SELECT_PROFILE,
    payload: profiles,
  };
}

export function loginSuccess() {
  return {
    type: actions.LOGIN_SUCCESS,
  };
}

export function saveProfileAgeRating(profileAgeRating) {
  return {
    type: actions.SAVE_PROFILE_AGE_RATING,
    payload: profileAgeRating,
  };
}

export function saveProfileName(profileName) {
  return {
    type: actions.SAVE_PROFILE_NAME,
    payload: profileName,
  };
}
